export enum AllowedGroups {
   ALARM_TRAY_ADMIN = <any>"ALARM_TRAY_ADMIN",
   ALARM_TRAY_EDITOR = <any>"ALARM_TRAY_EDITOR"
}